var _circle, _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFloatingButton({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_4333_33153)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 24,
    fill: "#0069D7"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4333_33153",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 12,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 12,
    width: 32,
    height: 32,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4333_33153)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.6758 32.8254C37.9734 26.2645 32.6062 18.876 25.2891 17.9627L25.3016 17.873C32.5151 17.873 38.0451 24.9128 38.0451 30.4665C38.0381 31.6226 37.9515 32.339 37.7971 32.859L37.6758 32.8254ZM37.2388 33.6593C36.7588 34.2775 36.1552 34.8999 35.4481 35.4908C34.1471 27.6032 28.6488 20.706 24.7616 18.6929L24.6783 18.7541C28.5877 22.1363 33.2504 28.7052 35.0637 35.8002C34.1388 36.5165 33.1397 37.1196 32.0856 37.5981C28.3966 33.1633 24.9573 24.6104 23.849 19.1831L23.7363 19.2188C23.7613 24.4871 27.3095 33.4306 31.6365 37.7946C30.6441 38.2085 29.6124 38.509 28.5591 38.6909C24.4113 36.9587 21.459 31.4109 21.459 25.7277C21.459 22.0177 22.532 19.7226 22.7396 19.2529L22.6512 19.216C22.4001 19.6165 20.8281 21.9104 20.8281 25.9157C20.8281 32.3397 23.8334 37.2498 27.8233 38.7961C26.3965 38.9615 24.954 38.8901 23.5481 38.5845L23.5184 38.6824C23.9452 38.8481 25.3933 39.4888 27.6023 39.4888C32.5988 39.4888 35.9764 36.2163 37.3361 33.7287L37.2388 33.6593Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1099 15.5547C23.3222 15.5547 18.8809 18.4364 18.8809 21.0705C18.8809 22.0895 19.7651 22.9503 21.5951 22.9503C25.8433 22.9503 29.7901 19.8735 29.7901 17.481C29.7901 16.222 28.6432 15.5547 27.1099 15.5547ZM28.622 17.4066C28.622 19.4233 24.9484 21.8885 21.8774 21.8885C20.5207 21.8885 19.7876 21.3256 19.7876 20.3968C19.7876 18.3512 23.503 15.9279 26.3835 15.9279C28.2615 15.9279 28.622 16.9353 28.622 17.4066Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3434 22.2894C17.2369 22.4835 16.8105 23.3636 16.8105 24.2654C16.8105 25.9378 18.4135 27.4904 21.3619 27.4904C27.0338 27.4904 33.5868 23.0892 33.5868 19.0038C33.5868 17.17 31.9401 16.1729 30.7967 15.9668L30.7753 16.0383C31.1309 16.1569 32.4337 16.7954 32.4337 18.4289C32.4337 21.6841 26.6479 26.1194 20.8846 26.1194C18.6783 26.1194 17.2882 24.9713 17.2882 23.2989C17.2882 22.7699 17.3927 22.4214 17.4204 22.3204L17.3434 22.2894Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.9545 19.3105C36.1101 19.435 37.0443 20.2558 37.0443 21.808C37.0443 27.1003 29.1782 32.3043 22.2241 32.3043C18.077 32.3043 16.1865 30.1457 16.2702 28.2291H16.3446C16.5071 29.2245 17.8536 31.0056 21.4832 31.0056C28.4461 31.0056 36.2203 25.6208 36.2203 20.9029C36.2203 20.0937 36.0118 19.5894 35.894 19.3651L35.9545 19.3105Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.5652 24.25C38.5978 24.3627 38.7672 24.8694 38.7672 25.6628C38.7672 31.55 30.8068 36.59 23.8834 36.59C20.3201 36.59 18.4593 34.7654 18.0664 34.0244L18.1298 33.975C19.1158 34.884 21.0578 35.5746 23.3243 35.5746C29.4388 35.5746 38.5627 30.6706 38.4813 24.2714L38.5652 24.25Z",
    fill: "#EFEFEF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_4333_33153",
    x: 0,
    y: 0,
    width: 60,
    height: 60,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_4333_33153"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4333_33153"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_4333_33153"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2,
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_4333_33153",
    result: "effect2_dropShadow_4333_33153"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_4333_33153",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloatingButton);
export default __webpack_public_path__ + "static/media/Floating Button.3c181f35f56fef1b6187f15ab3105305.svg";
export { ForwardRef as ReactComponent };